const sounds = {
  newOrder: {
    type: 'square',
    frequency: 1000,
    length: 400,
  },
}

const audioContext = window.AudioContext ? new window.AudioContext() : null
const masterGainNode: GainNode | null = audioContext && audioContext.createGain()
if (masterGainNode && audioContext) {
  masterGainNode.connect(audioContext.destination)
  // This controls the volume
  masterGainNode.gain.value = 0.2
}

export const playSound = (sound: string) => {
  if (!audioContext || !masterGainNode) {
    console.log('No audioContext')
    return
  }
  if (!sounds[sound]) {
    console.log(`Undefined sound ${sound}`)
    return
  }
  const { type, frequency, length } = sounds[sound]
  let osc: OscillatorNode | null = audioContext.createOscillator()
  osc.connect(masterGainNode)
  osc.type = type
  osc.frequency.value = frequency
  osc.start()
  setTimeout(() => {
    osc?.stop()
    osc = null
  }, length)
}
